var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"videoclaim"}},[_c('section',{staticClass:"w_10f8"},[_c('vidclbanner')],1),_c('section',[_c('vidclawtvid')],1),_c('section',{staticClass:"w_10f8"},[_c('vidclcont')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }